import api from "./api";

export const getPharmacyProfile = () =>
  api.get("/pharmacy/profiles/");

// Response includes inline patient_name, patient_pin, doctor_email, frequency_display
// from SerializerMethodFields — no separate patient profile fetch needed.
export const getPrescriptions = (params = {}) =>
  api.get("/pharmacy/prescriptions/", { params });

// Search pending prescriptions by patient PIN or name fragment.
// params: { pin } or { name }
export const searchPrescriptions = (params = {}) =>
  api.get("/pharmacy/prescriptions/search/", { params });

// Dispense: auto-assigns the acting pharmacist's pharmacy and marks as dispensed.
export const dispensePrescription = (id) =>
  api.post(`/pharmacy/prescriptions/${id}/dispense/`);

// Alias used by the new queue UI (same endpoint).
export const updatePrescriptionStatus = (id) =>
  api.post(`/pharmacy/prescriptions/${id}/dispense/`);

// Returns prescriptions dispensed by this pharmacist today.
export const getDispensedToday = () =>
  api.get("/pharmacy/prescriptions/dispensed-today/");

// Returns all active undispensed prescriptions directed to THIS pharmacy (FIFO queue).
export const getIncomingPrescriptions = () =>
  api.get("/pharmacy/prescriptions/incoming/");

// Mark a prescription as locally "ready for pickup" — tracked in UI state.
export const markPrescriptionReady = (id) =>
  api.post(`/pharmacy/prescriptions/${id}/dispense/`);  // placeholder; ready-state is tracked locally

// Returns all verified pharmacy profiles (accessible to DOCTOR and PATIENT roles).
export const getAllPharmacies = () =>
  api.get("/pharmacy/profiles/");

export const getInventory = (params = {}) =>
  api.get("/pharmacy/inventory/", { params });

export const addInventoryItem = (data) =>
  api.post("/pharmacy/inventory/", data);

export const updateInventoryItem = (id, data) =>
  api.patch(`/pharmacy/inventory/${id}/`, data);

export const getBillingRecords = (params = {}) =>
  api.get("/billing/records/", { params });

export const createBillingRecord = (data) =>
  api.post("/billing/records/", data);

export const markOutOfStock = (id, notes = "") =>
  api.post(`/pharmacy/prescriptions/${id}/mark-out-of-stock/`, { notes });

export const markAvailable = (id) =>
  api.post(`/pharmacy/prescriptions/${id}/mark-available/`);

export const bulkAddInventory = (items) =>
  api.post("/pharmacy/inventory/bulk/", items);

export const getMedicationNames = (q = "") =>
  api.get("/pharmacy/inventory/medication-names/", { params: q ? { q } : {} });

// ── Pharmacy notifications ────────────────────────────────────────────────────

export const getPharmacyNotifications = () =>
  api.get("/pharmacy/notifications/");

export const getPharmacyNotificationUnreadCount = () =>
  api.get("/pharmacy/notifications/unread-count/");

export const markPharmacyNotificationRead = (id) =>
  api.patch(`/pharmacy/notifications/${id}/mark-read/`);

export const markAllPharmacyNotificationsRead = () =>
  api.post("/pharmacy/notifications/mark-all-read/");
